var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloudSnow = function SvgIconCloudSnow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.568 4.034a5.375 5.375 0 1 1 2.057 10.341h-7.5a3.125 3.125 0 1 1 0-6.25h.005q.086 0 .172.004A7 7 0 0 0 7.25 9a1 1 0 1 0 2 0 5.375 5.375 0 0 1 3.318-4.966m-4.075.869a7.4 7.4 0 0 0-.678 1.267l-.693-.045a5.125 5.125 0 0 0 .003 10.25h7.5A7.375 7.375 0 1 0 8.493 4.903M16.5 20.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-6 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-3-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconCloudSnow;